export default "/assets/website/images/menu-tick.svg?53ab123163f082a595c982f50416acca";